var exports = {
  "W": "file-name-overflow__w2kn8A",
};

module.exports = exports;
